import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useUserInfo from '@/auth/useUserInfo';
import * as actions from '@/store/pageFrame/actions';
import { getUserAndAccountSettings } from '../template/template-api';

export function useGetUserAndAccountSettings() {
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = useUserInfo();

  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- dispatch is stable and intentionally excluded from the query key
  return useQuery({
    queryKey: ['get-user-and-account-settings'],
    async queryFn() {
      const response = await getUserAndAccountSettings();
      const userAndAccountSettings = response.result;

      // Redux is a fact of life in this project
      dispatch(actions.setSettings(userAndAccountSettings));
      return userAndAccountSettings;
    },
    onError(err) {
      console.error('Error getting settings', err);

      const msg = `Oops! Looks like some wires got crossed. Please logout and login again. If this persists, send a note to support@skyslope.com and they'll help you out`;
      // TODO: Having toast displaying be reliant on Redux is dumb.
      // Currently PageFrame listens for this state and handles displaying toasts.
      dispatch(actions.errorToast(msg));
    },
    enabled: Boolean(userInfo && userInfo?.provisioned && !location.pathname.includes('logout')),
  });
}
